(() => {
  "use strict";

  if (window.__HARDRIP_CHATTY_STABILITY_V20208__) return;
  window.__HARDRIP_CHATTY_STABILITY_V20208__ = true;

  const POPUP = ".Avada-Faqs_Popup";
  const SWIPER = ".Avada-Faqs-Header__Thumbnail--Swiper";
  const OPEN_CLASS = "Avada-Faqs_Popup--Open";
  const CLOSE_CLASS = "Avada-Faqs_Popup--Close";
  const HOME_SEARCH = "button.Avada-Faqs_Search-Article";
  const CLOSE_SELECTOR = [
    ".Avada-Faqs_HeaderClose-button",
    '[aria-label="Close"]',
    '[aria-label="Chiudi"]',
    '[title="Close"]',
    '[title="Chiudi"]',
    '[class*="HeaderClose"]'
  ].join(",");

  const installStyles = () => {
    if (document.getElementById("hardrip-chatty-v20208-style")) return;
    const style = document.createElement("style");
    style.id = "hardrip-chatty-v20208-style";
    style.textContent = `
      .Avada-Faqs_Popup :is(
        input[placeholder="Cerca aiuto" i],
        input[placeholder="Search for help" i],
        input[placeholder*="help" i]
      ),
      .Avada-Faqs_Popup:not(.homePage)
      :is([class*="Search"], [class*="search"])
      :is(input, textarea, [role="textbox"], [contenteditable="true"], [class*="Input"], [class*="input"]) {
        background: transparent !important;
        background-color: transparent !important;
        background-image: none !important;
        border: 0 !important;
        border-color: transparent !important;
        border-radius: 0 !important;
        outline: 0 !important;
        box-shadow: none !important;
        -webkit-box-shadow: none !important;
        appearance: none !important;
        -webkit-appearance: none !important;
      }

      @keyframes hardripChattyCloseV20208 {
        from {
          opacity: 1;
          transform: translate3d(0, var(--hardrip-chatty-drag-y, 0px), 0);
        }
        to {
          opacity: 1;
          transform: translate3d(0, 100dvh, 0);
        }
      }

      @media (max-width: 500px) {
        .Avada-Faqs_Popup.mobile.Avada-Faqs_Popup--Close {
          /* Chatty removes the closing popup after 200 ms; finish one frame
             earlier so iOS paints the final off-screen position first. */
          animation: hardripChattyCloseV20208 180ms cubic-bezier(.4, 0, 1, 1) both !important;
          transform-origin: center bottom !important;
          opacity: 1 !important;
        }

        .Avada-Faqs_Popup.mobile[data-hardrip-chatty-dragging="true"] {
          animation: none !important;
          transition: none !important;
          transform: translate3d(0, var(--hardrip-chatty-drag-y, 0px), 0) !important;
          opacity: 1 !important;
          will-change: transform;
        }

        .Avada-Faqs_Popup.mobile[data-hardrip-chatty-swipe-closing="true"]:not(.Avada-Faqs_Popup--Close) {
          animation: none !important;
          transition: none !important;
          transform: translate3d(0, var(--hardrip-chatty-drag-y, 0px), 0) !important;
          opacity: 1 !important;
        }

        .Avada-Faqs_Popup.mobile[data-hardrip-chatty-snapback="true"] {
          animation: none !important;
          transition: transform 220ms cubic-bezier(.22, 1, .36, 1) !important;
          transform: translate3d(0, 0, 0) !important;
          opacity: 1 !important;
          will-change: transform;
        }

        .Avada-Faqs_Popup.mobile ${SWIPER} {
          touch-action: none;
        }
      }
    `;
    (document.head || document.documentElement).appendChild(style);
  };

  let popup = null;
  let popupObserver = null;
  let bodyObserver = null;
  let settleTimer = 0;
  let resetToken = 0;
  let resetAttempts = 0;
  let swipeNode = null;
  let swipeCleanup = null;

  const clearSettleTimer = () => {
    if (settleTimer) window.clearTimeout(settleTimer);
    settleTimer = 0;
  };

  const isOpen = (element) =>
    element instanceof Element &&
    element.isConnected &&
    element.classList.contains(OPEN_CLASS) &&
    !element.classList.contains(CLOSE_CLASS);

  const isHome = (element) =>
    element instanceof Element &&
    (String(element.getAttribute("data-chatty-page") || "").toLowerCase() === "homepage" ||
      element.classList.contains("homePage") ||
      Boolean(element.querySelector(HOME_SEARCH)));

  const findBackButton = (element) => {
    if (!(element instanceof Element)) return null;
    for (const button of element.querySelectorAll('button,[role="button"]')) {
      if (button.matches(CLOSE_SELECTOR)) continue;
      const label = `${button.getAttribute("aria-label") || ""} ${button.getAttribute("title") || ""} ${button.textContent || ""}`;
      if (/indietro|back|torna|home/i.test(label) && !/close|chiudi/i.test(label)) return button;
    }
    return null;
  };

  const runSettledMaintenance = (token) => {
    settleTimer = 0;
    if (token !== resetToken || !isOpen(popup)) return;
    if (popup.hasAttribute("data-hardrip-chatty-dragging")) return;
    if (isHome(popup)) return;

    const back = findBackButton(popup);
    if (!back || resetAttempts >= 4) return;
    resetAttempts += 1;
    back.click();
    scheduleAfterQuietPeriod(900);
  };

  function scheduleAfterQuietPeriod(delay = 1100) {
    clearSettleTimer();
    const token = resetToken;
    settleTimer = window.setTimeout(() => runSettledMaintenance(token), delay);
  }

  const resetMotionState = (element) => {
    if (!(element instanceof Element)) return;
    element.removeAttribute("data-hardrip-chatty-dragging");
    element.removeAttribute("data-hardrip-chatty-snapback");
    element.removeAttribute("data-hardrip-chatty-swipe-closing");
    element.style.removeProperty("--hardrip-chatty-drag-y");
    // Remove only residue written by Chatty's broken native swipe routine.
    element.style.removeProperty("max-height");
    element.style.removeProperty("display");
  };

  const wireSwipe = () => {
    if (!(popup instanceof Element) || !popup.isConnected) return;
    const node = popup.querySelector(SWIPER);
    if (!(node instanceof Element) || node === swipeNode) return;

    swipeCleanup?.();
    swipeNode = node;

    let active = false;
    let dragging = false;
    let startY = 0;
    let currentY = 0;
    let startTime = 0;
    let lastY = 0;
    let lastTime = 0;

    const stopNativeSwipe = (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
    };

    const onTouchStart = (event) => {
      if (!(event.target instanceof Element) || !event.target.closest(SWIPER)) return;
      if (!isOpen(popup) || event.touches.length !== 1) return;
      stopNativeSwipe(event);
      const y = event.touches[0].clientY;
      active = true;
      dragging = false;
      startY = y;
      currentY = y;
      lastY = y;
      startTime = event.timeStamp;
      lastTime = event.timeStamp;
      popup.removeAttribute("data-hardrip-chatty-snapback");
      popup.removeAttribute("data-hardrip-chatty-swipe-closing");
      popup.style.removeProperty("max-height");
      popup.style.removeProperty("display");
    };

    const onTouchMove = (event) => {
      if (!(event.target instanceof Element) || !event.target.closest(SWIPER)) return;
      if (!active || event.touches.length !== 1) return;
      stopNativeSwipe(event);
      const y = event.touches[0].clientY;
      if (y >= currentY || event.timeStamp - lastTime > 80) {
        lastY = currentY;
        lastTime = event.timeStamp;
      }
      currentY = Math.max(startY, y);
      const distance = currentY - startY;
      if (!dragging && distance >= 4) {
        dragging = true;
        clearSettleTimer();
        popup.setAttribute("data-hardrip-chatty-dragging", "true");
      }
      if (dragging) {
        // A single compositor-only transform write makes the sheet follow the
        // finger; no layout property is read or changed during touchmove.
        popup.style.setProperty("--hardrip-chatty-drag-y", `${distance}px`);
      }
    };

    const finishTouch = (event) => {
      if (!(event.target instanceof Element) || !event.target.closest(SWIPER)) return;
      if (!active) return;
      stopNativeSwipe(event);
      const endY = event.changedTouches?.[0]?.clientY ?? currentY;
      currentY = Math.max(startY, endY);
      const distance = currentY - startY;
      popup.style.setProperty("--hardrip-chatty-drag-y", `${distance}px`);

      const recentDuration = Math.max(1, event.timeStamp - lastTime);
      const recentVelocity = Math.max(0, currentY - lastY) / recentDuration;
      const totalVelocity = distance / Math.max(1, event.timeStamp - startTime);
      const threshold = Math.min(170, popup.getBoundingClientRect().height * 0.2);
      const shouldClose = dragging && (distance >= threshold || (distance >= 48 && Math.max(recentVelocity, totalVelocity) >= 0.55));

      active = false;
      popup.removeAttribute("data-hardrip-chatty-dragging");

      if (shouldClose) {
        popup.setAttribute("data-hardrip-chatty-swipe-closing", "true");
        const close = popup.querySelector(CLOSE_SELECTOR);
        if (close instanceof HTMLElement) close.click();
        else document.getElementById("Avada-FAQ_WidgetTrigger")?.click();
      } else if (dragging) {
        popup.setAttribute("data-hardrip-chatty-snapback", "true");
        window.setTimeout(() => {
          if (!popup || popup.classList.contains(CLOSE_CLASS)) return;
          popup.removeAttribute("data-hardrip-chatty-snapback");
          popup.style.removeProperty("--hardrip-chatty-drag-y");
          scheduleAfterQuietPeriod(1100);
        }, 240);
      }

      dragging = false;
    };

    const options = { capture: true, passive: false };
    // Capture on the popup ancestor so Chatty's target-level max-height/display
    // handlers never receive a swipe that started on its header drag handle.
    popup.addEventListener("touchstart", onTouchStart, options);
    popup.addEventListener("touchmove", onTouchMove, options);
    popup.addEventListener("touchend", finishTouch, options);
    popup.addEventListener("touchcancel", finishTouch, options);

    swipeCleanup = () => {
      popup?.removeEventListener("touchstart", onTouchStart, options);
      popup?.removeEventListener("touchmove", onTouchMove, options);
      popup?.removeEventListener("touchend", finishTouch, options);
      popup?.removeEventListener("touchcancel", finishTouch, options);
      if (swipeNode === node) swipeNode = null;
    };
  };

  const disconnectPopup = () => {
    popupObserver?.disconnect();
    popupObserver = null;
    swipeCleanup?.();
    swipeCleanup = null;
    popup = null;
    clearSettleTimer();
  };

  const wirePopup = (candidate) => {
    if (!(candidate instanceof Element) || candidate === popup) return;
    disconnectPopup();
    popup = candidate;
    let wasOpen = isOpen(popup);
    if (wasOpen) resetMotionState(popup);
    wireSwipe();

    popupObserver = new MutationObserver((mutations) => {
      if (!popup?.isConnected) {
        disconnectPopup();
        return;
      }

      wireSwipe();
      const open = isOpen(popup);
      if (!open) {
        wasOpen = false;
        resetToken += 1;
        resetAttempts = 0;
        clearSettleTimer();
        return;
      }

      if (!wasOpen) {
        wasOpen = true;
        resetToken += 1;
        resetAttempts = 0;
        resetMotionState(popup);
      }

      if (mutations.some((mutation) => mutation.type === "childList" || mutation.attributeName === "data-chatty-page" || mutation.attributeName === "class")) {
        scheduleAfterQuietPeriod(1100);
      }
    });

    popupObserver.observe(popup, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "data-chatty-page"]
    });

    if (wasOpen) {
      resetToken += 1;
      resetAttempts = 0;
      scheduleAfterQuietPeriod(1100);
    }
  };

  const findPopup = () => {
    const candidate = document.querySelector(POPUP);
    if (candidate) wirePopup(candidate);
  };

  const boot = () => {
    installStyles();
    findPopup();
    if (!bodyObserver && document.body) {
      bodyObserver = new MutationObserver((mutations) => {
        if (mutations.some((mutation) =>
          [...mutation.addedNodes].some((node) =>
            node instanceof Element && (node.matches?.(POPUP) || node.querySelector?.(POPUP))
          )
        )) findPopup();
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();
